import { Capacitor } from "@capacitor/core";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "Utils/Storage/SessionStorage/SecureSessionStorage";
import { SessionStorageKeys } from "Utils/Storage/SessionStorage/SessionStorageKeys";

export const isNativePlatform = () => Capacitor.isNativePlatform();

export const getPlatform = () => Capacitor.getPlatform();

export const isAndroid = () => Capacitor.getPlatform() === "android";

export const isIOS = () => Capacitor.getPlatform() === "ios";

export const isWeb = () => !Capacitor.isNativePlatform();

// The Android TWA shell has no Capacitor bridge (the app runs as plain Chrome), so the
// Capacitor helpers above all report "web" inside it. The one signal Chrome gives us is
// the android-app://<package> referrer on launch — but SPA route changes keep it while a
// hard reload can lose it, so capture once at startup and persist for the session.
export const captureAndroidTwaFlag = () => {
  if (document.referrer.startsWith("android-app://")) {
    setSessionStorageItem(SessionStorageKeys.IsAndroidTwa, "true");
  }
};

export const isAndroidTwa = () =>
  getSessionStorageItem(SessionStorageKeys.IsAndroidTwa) === "true";

// Browser-OS detection from the user agent. Unlike the Capacitor helpers above,
// these work in any plain browser. iPadOS 13+ reports as "Macintosh", so we
// disambiguate desktop Safari from iPad via maxTouchPoints.
export const isIOSBrowser = () =>
  /iPhone|iPad|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export const isAndroidBrowser = () => /Android/i.test(navigator.userAgent);
